<img
	class="self-exclusion-warning-icon"
	obgImageContent="responsible-gaming.self-exclusion-warning-icon"
	alt="self-exclusion"
	obgImageContentGroup="common"
	tabindex="0"
/>

<h2 [innerHTML]="'self-exclusion.warning-title' | translate"></h2>

<p class="self-exclusion-warning-body" [innerHTML]="'self-exclusion.warning-message' | translate"></p>

<p class="self-exclusion-interval">{{exclusionPeriod?.text | translate }}</p>

<form class="self-exclusion-warning-form" [formGroup]="formGroup" (ngSubmit)="onSubmit()">
	<p
		*ngIf="isJurisdictionLpcse"
		class="self-exclusion-disclaimer"
		[innerHtml]="selfExclusionDisclaimerLpcse | translate"
	></p>
	<mat-checkbox
		color="primary"
		class="self-exclusion-disclaimer"
		formControlName="selfExclusionDisclaimer"
		data-test-id="checkbox-self-exclusion-disclaimer"
	>
		<span [innerHtml]="selfExclusionDisclaimer | translate"></span>
	</mat-checkbox>
	<button
		class="self-exclusion-btn-submit"
		type="submit"
		[disabled]="formGroup.invalid"
		mat-flat-button
		color="accent"
		test-id="alert-button-general.confirm"
		data-test-id="alert-button-general.confirm"
	>
		{{ 'general.confirm' | translate }}
	</button>
</form>
<button
	class="self-exclusion-btn-cancel"
	mat-flat-button
	test-id="alert-button-general.cancel"
	data-test-id="alert-button-general.cancel"
	(click)="cancelSelfExclusion()"
>
	{{ 'general.cancel' | translate }}
</button>
